module.exports = __webpack_public_path__ + "img/public_office.f434a335.png";